const STORAGE_KEY = "rosiDeviceId";
let memoryId = null;
let persisted = false;

const generateId = () => {
  try {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      return crypto.randomUUID();
    }
  } catch (e) {
    // fall through to the Math.random based id
  }
  return `web-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2, 12)}${Math.random().toString(36).slice(2, 12)}`;
};

// Stable per-browser id sent as `deviceId` at login/logout. Persisted in
// localStorage; falls back to an in-memory value if storage is unavailable.
export const getDeviceId = () => {
  let storageReadable = false;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    storageReadable = true;
    if (stored) {
      memoryId = stored;
      persisted = true;
      return stored;
    }
  } catch (e) {
    // storage unavailable: use the in-memory value below
  }
  // Storage was cleared after we saved an id: start a new one. If we never
  // managed to save it (or storage is unreadable), keep the in-memory id.
  if (!memoryId || (storageReadable && persisted)) {
    memoryId = generateId();
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, memoryId);
    persisted = true;
  } catch (e) {
    persisted = false;
  }
  return memoryId;
};

export default getDeviceId;
